export default __webpack_public_path__ + "static/media/cobblestonefloor.53c61e83.png";